<ion-button
  fill="clear"
  (click)="open($event)"
  tooltip="Click to visit our help center for more information."
  aria-label="Help Menu">
  <ion-icon src="/assets/icons/16px/info-outline.svg"> </ion-icon>
</ion-button>
